<div class="app_name"><span class="app_name_case">{{ firstPart }}</span><span>{{ lastPart }}</span></div>